import React, {useEffect, useState} from "react";
import {Container} from "reactstrap";
import Button from "reactstrap/lib/Button";
import Card from "reactstrap/lib/Card";
import CardBody from "reactstrap/lib/CardBody";
import Col from "reactstrap/lib/Col";
import ListGroupItem from "reactstrap/lib/ListGroupItem";
import Row from "reactstrap/lib/Row";
import SimpleHeader from "components/Headers/SimpleHeader.js";
import Alert from "reactstrap/lib/Alert";
import {showLoadingRecordsMessage} from "config/config";
import CardTitle from "reactstrap/lib/CardTitle";
import walletService from "services/walletService";
import utils from "util/CustomUtil";

export default function MyWallet(props) {
  const [wallet, setWallet] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      setIsLoading(true);
      const wallet = await walletService.fetchWallet();
      setWallet(wallet);
      setIsLoading(false);
    } catch (ex) {
      setIsLoading(false);
    }
  }

  return (
    <div>
      <SimpleHeader
        name="My Wallet"
        parentName="Tables"
        description="View and manage your funds."
      />
      <Container className="mt--6" fluid>
        {isLoading
          ? showLoadingRecordsMessage("Loading Dashboard. Please wait...")
          : loadDashboardList(props, wallet, fetchData)}
      </Container>
    </div>
  );
}

function loadDashboardList(props, wallet, fetchData) {
  return (
    <>
      {/* <Row>
        <div className="col-lg-8 offset-lg-2 col-md-10 offset-md-1 col-sm-12">
          <Card className="bg-gradient-white border border-primary text-primary">
            <CardBody>
              <Row>
                <Col className="my-auto text-center">
                  <div className="text-uppercase mb-0">Wallet Balance</div>
                  <div className="display-3">
                    {loadBalance(wallet, "workingBalance", fetchData)}
                  </div>
                </Col>
                <Col>
                  <Card className="bg-gradient-success text-white mb-2">
                    <CardBody className="pt-2 pb-0">
                      <Row className="mb-2">
                        <div className="col text-uppercase pt-1">Cash</div>
                        <Col className="col-auto h2 font-weight-normal mb-0 text-white">
                          {loadBalance(wallet, "cashBalance", fetchData)}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                  <Card className="bg-gradient-success text-white mb-0">
                    <CardBody className="pt-2 pb-0">
                      <Row className="mb-2">
                        <div className="col text-uppercase pt-1">Cash Back</div>
                        <Col className="col-auto h2 font-weight-normal mb-0 text-white">
                          {loadBalance(wallet, "cashBackBalance", fetchData)}
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Row> */}

      <Row>
        <div className="col-lg-4 offset-lg-2 col-md-5 offset-md-1 col-sm-6">
          <Card className="bg-gradient-white">
            <CardBody className="border border-light rounded">
              <Row>
                <div className="col">
                  <CardTitle className="text-uppercase mb-0 text-primary">
                    Wallet <br className="d-none d-md-block d-lg-none" />
                    Balance
                  </CardTitle>
                  {loadBalance(wallet, "cashBalance", fetchData, "primary")}
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-primary text-white rounded-circle shadow">
                    <i className="ni ni-money-coins" />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
        <div className="col-lg-4 col-md-5 col-sm-6">
          <Card className="bg-gradient-success">
            <CardBody className="border border-success rounded">
              <Row>
                <div className="col">
                  <CardTitle className="text-uppercase mb-0 text-white">
                    {wallet
                      ? wallet.organizationWallet
                        ? "Referal Bonus"
                        : "Cash Back Balance"
                      : ""}
                  </CardTitle>
                  {loadBalance(wallet, "cashBackBalance", fetchData, "white")}
                </div>
                <Col className="col-auto">
                  <div className="icon icon-shape bg-white text-success rounded-circle shadow">
                    <i className="fas fa-wallet" />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </div>
      </Row>
      <Row>
        <div className="col-lg-4 offset-lg-2 col-md-5 offset-md-1 col-sm-6">
          <Button
            color="primary"
            type="button"
            size="lg"
            onClick={() => props.history.push("/base/wallet/fund")}
            block
            className="mb-4"
          >
            <span className="text-lg">Fund Wallet</span>
          </Button>
        </div>
        <div className="col-lg-4 col-md-5 col-sm-6">
          <Button
            color="primary"
            type="button"
            size="lg"
            onClick={() => props.history.push("/base/wallet/transactions")}
            block
            className="mb-4"
          >
            <span className="text-lg">Transaction History</span>
          </Button>
        </div>
        {/* <div className="col-lg-4 col-md-5 col-sm-6">
          <Button
            color="primary"
            type="button"
            size="lg"
            onClick={() => props.history.push("/base/wallet/withdraw")}
            block
            className="mb-4"
          >
            <span className="text-lg">Withdraw Funds</span>
          </Button>
        </div> */}
      </Row>
      {/* <Row>
        <div className="col-lg-4 offset-lg-2 col-md-5 offset-md-1 col-sm-6">
          <Button
            color="primary"
            type="button"
            size="lg"
            onClick={() => props.history.push("/base/wallet/transactions")}
            block
            className="mb-4"
          >
            <span className="text-lg">Transaction History</span>
          </Button>
        </div>
        <div className="col-lg-4 col-md-5 col-sm-6">
          <Button
            color="primary"
            type="button"
            size="lg"
            onClick={() => props.history.push("/base/wallet/link")}
            block
            className="mb-4"
          >
            <span className="text-lg">Link Account</span>
          </Button>
        </div>
      </Row> */}

      <Row>
        <div className="col-lg-4 offset-lg-2 col-md-5 offset-md-1 col-sm-6"></div>
        <div className="col-lg-4 col-md-5 col-sm-6"></div>
      </Row>
    </>
  );
}

function loadBalance(wallet, property, fetchData, color) {
  const balance = wallet ? Number(wallet[property]) : 0;
  return (
    <span
      className={`h1 font-weight-bold mb-0 text-${
        balance >= 0 ? color : "danger"
      }`}
    >
      {wallet ? (
        <>&#8358; {utils.numberFormatter(balance, 2)}</>
      ) : (
        color === "primary" && (
          <Button
            type="text"
            color={color}
            size="sm"
            onClick={() => fetchData()}
            className="text-left"
          >
            retry
          </Button>
        )
      )}
    </span>
  );
}

function noDashboardsMessage() {
  return (
    <Alert color="default" className="text-center">
      <h4 className="alert-heading">No Configured Dashboards!</h4>
      <div className="alert-body">
        All your configured dashboards will show up here. Right now you have no
        configured dashboards.
      </div>
    </Alert>
  );
}

function loadTable(dashboardList, props) {
  const list = [];
  dashboardList.forEach((dashboard) => {
    list[list.length] = (
      <ListGroupItem className="px-0">
        <Row className="align-items-center">
          <div className="col ml--2">
            <a
              href="#pablo"
              className={`font-weight-bold text-${
                  list.length % 2 === 0 ? "default" : "primary"
              }`}
              onClick={(e) => e.preventDefault()}
            >
              {dashboard.name}
            </a>
            <br />
            <span className="muted">{dashboard.reportCount} Reports</span>
          </div>
          <Col className="col-auto">
            <a
              role="Button"
              className={`btn btn-sm btn-${
                  list.length % 2 === 0 ? "default" : "primary"
              }`}
              target="_blank"
              href=""
              onClick={(e) => {
                e.preventDefault();
                props.history.push(`/base/dashboard/${dashboard.id}`);
              }}
            >
              Launch
            </a>
          </Col>
        </Row>
      </ListGroupItem>
    );
  });
  return list;
}
